// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ComponentTitleAmpersandFragmentDoc = gql`
    fragment componentTitleAmpersand on ComponentTitleAmpersand {
  __typename
  null
}
    `;